import "./MainInformation.css";
import MainInfoSection from "./mainInfoSection/MainInfoSection";
import SecondaryInfoSection from "./secondaryInfoSection/SecondaryInfoSection";

function MainInformation() {
  return (
    <main className="main" id="about">
      <MainInfoSection />
      <SecondaryInfoSection />
    </main>
  );
}
export default MainInformation;
